import { BeWizrModel } from './BeWizrModel'

export class BeWizrProfile extends BeWizrModel {

  hasDashboardAccess:       boolean = false
  hasNonParticipantCourses: boolean = false

  organization!:           BeWizrOrganization
  organizationTags!:       BeWizrOrganizationTag[] | null
  availableOrganizations!: BeWizrOrganization[] | null

}

export interface BeWizrOrganization {
  id:    string
  title: string
}

export interface BeWizrOrganizationTag {
  tag:                 string
  organizationalUnits: BeWizrOrganizationalUnit[]
}

export interface BeWizrOrganizationalUnit {
  id:    string
  title: string
}